import React from 'react'
import { Register } from '../components'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createUser } from 'actions'
import { withRouter } from 'react-router'

const RegisterContainer = props => <Register {...props} />

function mapStateToProps(state) {
  return {
    socialAuthToken: state.user.socialAuthToken,
    OAuthProvider: state.user.OAuthProvider,
    user: state.user.personalData,
    isLoading: state.user.isLoading,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ createUser }, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RegisterContainer))



// WEBPACK FOOTER //
// ./src/features/authentication/containers/RegisterContainer.js